import {get,post} from "./request.js";
export default {
    // 公司信息
    basicInfo(data) {
        return post('/index/index', data)
    },
    // 子公司
    zcompany(data) {
        return post('/index/zcompany', data)
    },
    // 企业荣誉
    honor(data) {
        return post('/index/honor', data)
    },
    // 分类
    indexCate(data) {
        return post('/index/indexcate', data)
    },
    // 轮播图
    indexBanner(data) {
        return post('/index/indexbanner', data)
    },
    // 轮播图下方的图
    bannerNext(data) {
        return post('/index/bannernext', data)
    },
    // 点击产品中心
    product(data) {
        return post('/index/product', data)
    },
    // 查看列表
    productList(data) {
        return post('/index/productlist', data)
    },
    // 根据列表id产看商品详情
    productdt(data) {
        return post('/index/productdt', data)
    },
    // 博物馆导览
    bwgdl(data) {
        return post('/index/bwgdl', data)
    },
    // 点击新闻资讯
    news(data) {
        return post('/index/news', data)
    },
    // 新闻列表
    newslist(data) {
        return post('/index/newslist', data)
    },
     // 新闻详情
    newsdt(data) {
        return post('/index/newsdt', data)
    },
    // 地图
    ditupost(data) {
        return post('/index/ditupost', data)
    },
    // 新闻详情上一篇，下一篇
    upnextbook(data) {
        return post('/index/upnextbook', data)
    },
    // 判断国内国外
    nowClientIP(data) {
        return post('/index/nowClientIP', data)
    },
    // 所有省 手机端用
    phonesheng(data) {
        return post('/index/phonesheng', data)
    },
    // 根据省获取市
    phoneshi(data) {
        return post('/index/phoneshi', data)
    },
    // 门店地址 手机电脑通用
    mdstroe(data) {
        return post('/index/mdstroe', data)
    },
    // 加盟表单+发送邮件（未填写字段传 “未填写”）
    franchise(data) {
        return post('/index/franchise', data)
    },
    // 新闻搜索
    searchnew(data) {
        return post('/index/searchnew', data)
    },
    // 新闻搜索
    searchnew(data) {
        return post('/index/searchnew', data)
    },
    // 获取验证码图片（base64）
    hqcaptcha(data) {
        return post('/index/hqcaptcha', data)
    },
    // 验证
    check(data) {
        return post('/index/check', data)
    },
    // 新闻，点击获取微信二维码
    phpcodes(data) {
        return post('/index/phpcodes', data)
    },

    /* 英文站接口 */
    // 栏目
    enIndex(data) {
        return post('/English/index', data)
    },
    // 幻灯片
    enBanner(data) {
        return post('/English/banner', data)
    },
    // 名酒
    liquor(data) {
        return post('/English/liquor', data)
    },
    // 关于我们、公司介绍
    eprofile(data) {
        return post('/English/eprofile', data)
    },
    // 里程碑
    eglorious(data) {
        return post('/English/eglorious', data)
    },
    // 产品系列
    productxl(data) {
        return post('/English/productxl', data)
    },
    // 产品列表
    enProductlist(data) {
        return post('/English/productlist', data)
    },
    // 产品详情
    enProductdt(data) {
        return post('/English/productdt', data)
    },
    // 核心优势
    eadvys(data) {
        return post('/English/eadvys', data)
    },
    // 英文搜索
    enSearch(data) {
        return post('/English/productsearch', data)
    },
    // 关于我们里程碑7条记录
    enlcb(data) {
        return post('/English/lcb', data)
    },
}
